<template>
  <div class="containerNovelties">
    <div v-if="loading" class="text-center">
      <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else class="form-container">
      <v-form ref="form" lazy-validation class="mt-5 mx-auto col-sm-8 col-md-6">
        <div class="add-image">
          <span class="text-image">Imagen Novedad</span>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs" v-on="on">
                <label for="file-input">
                  <v-icon dark>mdi-plus</v-icon>
                </label>
              </v-btn>
            </template>
            <span>Seleccionar una Imagen</span>
            <!-- Input de tipo archivo oculto -->
            <input type="file" @change="onFileChange" id="file-input" accept="image/*" style="display: none" />
          </v-tooltip>
        </div>

        <v-text-field color="secondary" label="*Título" placeholder="Ingrese el título" :counter="50" :maxlength="50"
          required :rules="rulesTitle" v-model="formData.title">
        </v-text-field>

        <v-textarea color="secondary" label="*Mensaje" placeholder="Ingrese el Mensaje" :counter="100" :maxlength="100"
          required :rules="rulesMessage" v-model="formData.message">
        </v-textarea>

        <v-select color="secondary" label="*Funcionalidad a la que pertenece" placeholder="Selecciona una funcionalidad" required 
          :items="listFunctionalities" item-text="name" item-value="screenId" :rules="rulesFuncionality" v-model="formData.functionalityId">
        </v-select>

        <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" color="secondary" offset-y
          max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="formData.startDate" label="*Fecha Inicio" color="secondary" :rules="startDateRules"
              readonly v-bind="attrs" v-on="on" disabled></v-text-field>
          </template>
          <v-date-picker v-model="localStartDate" color="primary" @change="handleStartDateChange"></v-date-picker>
        </v-menu>

        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" color="secondary" offset-y
          max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="formData.endDate" label="*Fecha Fin" color="secondary" :rules="endDateRules" readonly
              v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="localEndDate" color="primary" @change="handleEndDateChange"></v-date-picker>
        </v-menu>

        <v-autocomplete color="secondary" label="*Visible para" placeholder="Selecciona una o más empresas"
          :rules="rulesCompany" v-model="formData.companyIds" v-if="this.roleId == 1" required multiple clearable chips
          :items="listCompanies" item-text="name" item-value="companyId">
          <template v-slot:item="{ item }">
            {{ item.name }} (ID:{{ item.identificationNumber }})
          </template>
        </v-autocomplete>

        <v-select color="secondary" label="*Estado" placeholder="Selecciona un estado" required :items="listStatus"
          item-text="nameStatus" item-value="valueStatus" :rules="rulesStatus" v-model="formData.status">
        </v-select>
      </v-form>
      <div class="mobile-view">
        <div v-if="formData.image" class="image-square">
          <!-- Muestra imagen seleccionada -->
          <img v-if="allowedImageTypes.includes(formData.image.type)" 
          :src="generateImageUrlPreview(formData.image)" alt="Imagen cargada" />

          <!-- Muestra imagen si lo trae el servicio -->
          <img v-else :src="formData.image" alt="Imagen cargada" />
        </div>
        <!-- Muestra imagen si NO lo trae el servicio -->
        <div v-else class="text-center">
          <p>Aquí visualizas la imagen seleccionada</p>
        </div>
        <div class="mobile-text">
          <h3>{{ formData.title }}</h3>
          <p>{{ formData.message }}</p>
          <h3 v-if="formData.functionalityId" class="text-right"> 
            Ir a {{ this.functionNameSelect }} <v-icon color="primary">mdi-arrow-right</v-icon>  
          </h3>
        </div>
      </div>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab fixed bottom right dark Large color="primary" @click="submitForm" v-bind="attrs"
            v-on="on"> 
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>Actualizar Novedad</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import {
  ACTION_GET_FUNCTIONALITIES,
  ACTION_GET_COMPANIES,
  GET_FUNCTIONALITIES,
  GET_STATE_LOADING,
  GET_COMPANIES,
  COMPANIES_M,
} from "@/views/companies/store/types/types.js";

import {
  ACTION_PUT_UPDATE_NOVELTIES,
  NOVELTIES_M,
} from "@/views/novelties/store/types/types.js";

import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  props: {
    novelty: {
      required: true
    }
  },
  data() {
    return {
      formData: {
        newsUpdateId: this.novelty.newsUpdateId,
        image: this.novelty.imageUrl,
        title: this.novelty.title,
        message: this.novelty.message,
        functionalityId: this.novelty.functionality,
        startDate: this.novelty.startDate,
        endDate: this.novelty.endDate,
        companyIds: this.novelty.companies ? this.novelty.companies : [],
        status: this.novelty.status
      },
      functionNameSelect: null,
      listStatus: [
        {
          idStatus: 1,
          nameStatus: "Visible",
          valueStatus: true
        },
        {
          idStatus: 2,
          nameStatus: "Oculto",
          valueStatus: false
        }
      ],
      allowedImageTypes: [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
      ],
      rulesTitle: [ v => !!v || 'Título es requerido' ],
      rulesMessage: [ v => !!v || 'Mensaje es requerido' ],
      rulesFuncionality: [ v => !!v || 'Funcionalidad a la que pertenece es requerido' ],
      rulesCompany: [ v => !!v || 'Visible para es requerido' ],
      rulesStatus: [ v => v != null || 'Estado es requerido' ],
      startDateRules: [
        v => !!v || 'Fecha Inicio es requerido',
      ],
      endDateRules: [
        v => !!v || 'Fecha Fin es requerido',
      ],
      menu1: false, // Para el date picker de fecha inicio
      menu2: false, // Para el date picker de fecha fin
      localStartDate: null,
      localEndDate: null,
      roleId: null
    };
  },
  async mounted() {
    await this.actionGetFunctionalities();
    this.roleId = sessionStorage.getItem('roleId');
    if (this.roleId == 1) {
      await this.actionGetCompanies();
    }
    this.dataInitial();
  },
  computed: {
    ...mapGetters({
      listFunctionalities: [`${COMPANIES_M}${GET_FUNCTIONALITIES}`],
      listCompanies: [`${COMPANIES_M}${GET_COMPANIES}`],
      loading: `${NOVELTIES_M}${GET_STATE_LOADING}`,
    }),
  },
  methods: {
    ...mapActions({
      postActionUpdateNovelties: `${NOVELTIES_M}${ACTION_PUT_UPDATE_NOVELTIES}`,
      actionGetFunctionalities: `${COMPANIES_M}${ACTION_GET_FUNCTIONALITIES}`,
      actionGetCompanies: `${COMPANIES_M}${ACTION_GET_COMPANIES}`,
    }),
    onFileChange(event) { 
      const file = event.target.files[0];
      if (!file) return;

      // Validar tipo
      if (!this.allowedImageTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
        });
        return;
      }
      this.formData.image = file;
    },
    generateImageUrlPreview(file) {
      const preview = URL.createObjectURL(file);
      return preview;
    },
    handleStartDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
        console.error("Invalid date object:", date);
        return;
      }

      this.localStartDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.startDate = date;
      this.validateStartDate(modifiedDate);
      this.menu1 = false;
    },

    validateStartDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      if (selectedDate < today) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha inicial no puede ser anterior a la fecha actual.",
        });
        this.localStartDate = null;
        this.formData.startDate = null;
        return;
      }

      const anioActual = new Date().getFullYear();
      const anioSeleccionado = modifiedDate.getFullYear();
      if (anioSeleccionado > anioActual) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha inicial no puede ser superior al año actual.",
        });
        this.localStartDate = null;
        this.formData.startDate = null;
        return;
      }

      if (this.formData.endDate != null) {
        if (this.formData.startDate > this.formData.endDate) {
          Swal.fire({
            icon: "error",
            title: "Fecha no válida",
            text: "La fecha inicial no puede ser superior la fecha final.",
          });
          this.localStartDate = null;
          this.formData.startDate = null;
          return;
        }
      }
    },

    handleEndDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
        console.error("Invalid date object:", date);
        return;
      }
      this.localEndDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.endDate = date;
      this.validateEndDate(this.localEndDate, modifiedDate);
      this.menu2 = false;
    },

    validateEndDate(localEndDate, modifiedDate) {
      if (localEndDate < this.formData.startDate) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha final no puede ser inferior a la fecha inicial.",
        });
        this.localEndDate = null;
        this.formData.endDate = null;
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      if (selectedDate < today) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha final no puede ser anterior a la fecha actual.",
        });
        this.localEndDate = null;
        this.formData.endDate = null;
        return;
      }
      const anioActual = new Date().getFullYear();
      const anioSeleccionado = modifiedDate.getFullYear();
      if (anioSeleccionado > anioActual) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha final no puede ser superior al año actual.",
        });
        this.localEndDate = null;
        this.formData.endDate = null;
        return;
      }
    },

    clearForm() {
      this.formData.image = '';
      this.formData.title = '';
      this.formData.message = '';
      this.formData.functionalityId = '';
      this.formData.startDate = '';
      this.formData.endDate = '';
      this.formData.companyIds = '';
      this.formData.status = '';
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join('<br>');
          Swal.fire({
            icon: 'error',
            title: 'Errores de validación',
            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });

          return;
        }

        const save = await this.postActionUpdateNovelties(this.formData);
        if (!save) {
          return Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Debes diligenciar los campos'
          })
        }
        await this.clearForm();
      } catch (error) {
        console.error("Fallo al enviar")
      }
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      // Validación de otros campos
      if (!this.formData.image) {
        errors.image = 'Imagen Novedad';
      }

      if (!this.formData.title) {
        errors.title = 'Título';
      }

      if (!this.formData.message) {
        errors.message = 'Mensaje';
      }

      if (!this.formData.functionalityId) {
        errors.functionalityId = 'Funcionalidad a la que pertenece';
      }

      if (!this.formData.startDate) {
        errors.startDate = 'Fecha Inicio';
      }

      if (!this.formData.endDate) {
        errors.endDate = 'Fecha Fin';
      }

      if (this.roleId == 1) {
        if (this.formData.companyIds.length == 0) {
          errors.companyIds = 'Visible para';
        }
      }

      if (this.formData.status == null) {
        errors.status = 'Estado';
      }

      return errors;
    },
    selectedFunction(){
      const foundFunction = this.listFunctionalities.find(e => e.screenId == this.formData.functionalityId || e.name == this.formData.functionalityId );
      if (foundFunction) {
        this.functionNameSelect = foundFunction.name;
      }
    },

    dataInitial(){
      const foundFunction = this.listFunctionalities.find(e => e.name == this.formData.functionalityId );
      if (foundFunction) {
        this.formData.functionalityId = foundFunction.screenId;
        this.functionNameSelect = foundFunction.name;
      }

      if (this.roleId == 1) {
        const idCompanies = this.novelty.companies.map(e => e.companyId);
        this.formData.companyIds = idCompanies;
      }

      const foundStatus = this.listStatus.find(e => e.nameStatus == this.formData.status );
      if (foundStatus) {
        this.formData.status = foundStatus.valueStatus;
      }
    }
  },
  watch: {
    'formData.functionalityId'(newValue) {
      if (newValue) {
        this.selectedFunction();
      }
    }
  }
};
</script>

<style lang="css" scoped>
.form-container {
  display: flex;
  gap: 20px;
}

.add-image {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-image {
  color: #ff7900;
  margin-bottom: 30px;
}

.mobile-view {
  background: #ff790010;
  border-radius: 15px;
  overflow: hidden;
  width: 400px;
  min-height: 300px;
  max-height: max-content;
  margin: 0 auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.image-square img {
  width: 100%;
  max-height: 300px;
}

.mobile-text,
h3 {
  color: #6E17A5;
}

.mobile-text {
  font-family: "Amsi Pro", sans-serif;
  color: #5D6E82;
  padding: 0 20px 20px;
}

span {
  text-align: right;
}

@media screen and (max-width: 799px) {
  .form-container {
    display:block;
  }
}
</style>
